<template>
  <div id="ContentMemberList">
    <div class="allSearch">
      <div class="newSearch d_flex">
        <div style="white-space: normal;width: auto">
          <p>
            <span>姓名</span><input class="allInput" type="text" placeholder="姓名" v-model="postData.name">
          </p>
          <p v-if="onSearch">
            <span>性别</span>
            <select class="allSelect" v-model="postData.gender" style="width: 160px">
              <option value="-1">未知</option>
              <option value="0">男</option>
              <option value="1">女</option>
              <option value="2">全部</option>
            </select>
          </p>
          <p>
            <input class="allInput" type="text" placeholder="工作邮箱" v-model="postData.email">
          </p>
          <p  v-if="onSearch">
            <input class="allInput" type="text"  v-model="postData.company_Name" placeholder="分公司">
          </p>
          <p  v-if="onSearch">
            <input class="allInput" type="text" v-model="postData.location" placeholder="所在地">
          </p>
          <p  v-if="onSearch">
            <input class="allInput" type="text" v-model="postData.building_Long" placeholder="地址">
          </p>
          <p>
            <input class="allInput" type="text" v-model="postData.org_Acronym" placeholder="部门">
          </p>
          <p  v-if="onSearch">
            <allSelect :chooseData="allcontent" :needReturn="'id'" :placeholder="'已关注'" :matchValue="'typeName'" :showValue="'{{typeName}}'" :multiple="true" v-model="postData.IsAttention">
            </allSelect>
          </p>
        </div>
        <div style="width: auto">
          <span class="colorCH c_p" style="text-decoration: underline" @click="tewoSearch()">{{onSearch ? '快速搜索':'高级搜索'}}</span>
          <button class="redButton" @click="getList(1)">
            <i class="icon iconfont iconsousuo"></i>
            <span>搜索</span>
          </button>
          <button @click="clearPostData" class="cancelButtonTwo">
            清空
          </button>
        </div>
      </div>
    </div>
    <div class="allTablePlace">
      <div class="d_flex m_b_10">
        <div>查看成员</div>
        <div>
          <button class="cancelButtonTwo" @click="allReturn">返回</button>
        </div>
      </div>
      <div>
        <table cellspacing="0" class="allTable">
          <thead>
          <tr>
            <th>姓名</th>
            <th class="t_c">性别</th>
            <th>工作邮箱</th>
            <th>分公司</th>
            <th>所在地</th>
            <th>地址</th>
            <th>部门</th>
            <th class="t_c">已关注</th>
            <th class="t_c">操作</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in myList" :key="index">
            <td width="5%" class="NoWrap" style="max-width: 30px" :title="item.name">{{item.name}}</td>
            <td width="5%" class="t_c NoWrap" :title="$commonJs.getGender(item.gender)">{{$commonJs.getGender(item.gender)}}</td>
            <td width="10%" class="NoWrap" style="max-width: 100px;" :title="item.email">{{item.email}}</td>
            <td width="10%" class="NoWrap" style="max-width: 100px;" :title="item.company_Name">{{item.company_Name}}</td>
            <td width="5%" class="NoWrap" style="max-width: 50px;" :title="item.location">{{item.location}}</td>
            <td width="10%" class="NoWrap" style="max-width: 100px;" :title="item.building_Long">{{item.building_Long}}</td>
            <td width="10%" class="NoWrap" style="max-width: 100px;" :title="item.org_Acronym">{{item.org_Acronym}}</td>
            <td width="5%" class="t_c">{{item.isAttention ? '是': '否'}}</td>
            <td width="5%" style="cursor: pointer;text-decoration:underline #408DEB;" class="colorBlue t_c" @click="viewUserList(item)">查看</td>
          </tr>
          </tbody>
        </table>
      </div>
      <page v-if="totalPage !== 0" :totalCount="totalCount" v-on:on-getList="getList($event)" :totalPage="totalPage" :page="page" :explain="0"></page>
    </div>

    <model v-if="showModel" :buttonType="2" :title="'用户信息'" :minWidth="'800px'" v-on:on-cancel="cancelModel()" v-on:on-confirm="confirModel()">
      <!--      <div class="modelInput"><span>账号名称</span><span><input class="allInput" type="text"></span></div>-->
      <div id="modelSwitah" class="m_10">
<!--        <div class="d_i font16 f_w">-->
<!--          <input v-model="tabSwitch" :value="1" type="radio" class="allTabRadio" name="swithTab" id="modelSwitah1">-->
<!--          <label for="modelSwitah1">用户信息</label>-->
<!--        </div>-->
<!--        <div class="d_i  font16 m_l_10 f_w">-->
<!--          <input v-model="tabSwitch"  :value="2" type="radio" class="allTabRadio" name="swithTab" id="modelSwitah2">-->
<!--          <label for="modelSwitah2">应用列表</label>-->
<!--        </div>-->
        <div class="p_r">
          <div :class="tabSwitch === 1 ? 'tabShowPage p_r' : 'tabNoShow p_a'">
            <dl class="userInformation">
              <dd><span>姓名：</span><abbr>{{userDetails.name}}</abbr></dd>
              <dd><span>性别：</span><abbr>{{$commonJs.getGender(userDetails.gender)}}</abbr></dd>
              <dd><span>工作邮箱：</span><abbr>{{userDetails.email}}</abbr></dd>
              <dd><span>分公司：</span><abbr>{{userDetails.company_Name}}</abbr></dd>
              <dd><span>所在地：</span><abbr>{{userDetails.location}}</abbr></dd>
              <dd><span>地址：</span><abbr>{{userDetails.building_Long}}</abbr></dd>
              <dd><span>部门：</span><abbr>{{userDetails.org_Acronym}}</abbr></dd>
              <dd><span>职位：</span><abbr>{{userDetails.title}}</abbr></dd>
              <dt><span>企业微信ID:</span><abbr>{{userDetails.openId}}</abbr></dt>
              <dt><span>Device ID:</span><abbr><div style="margin-right: 5px;" v-for="(item, index) in userDetails.deviceIdList" :key="index" >{{item}}</div></abbr></dt>
              <dd><span>注册时间：</span><abbr>{{$commonJs.returnNewDate(userDetails.lastPasswordModificationTime)}}</abbr></dd>
              <dd><span>已关注：</span><abbr>{{userDetails.isAttention ? '是' : '否'}}</abbr></dd>
            </dl>
          </div>
<!--          <div :class="tabSwitch === 2 ? 'tabShowPage p_r' : 'tabNoShow p_a'" style="max-height: 400px;overflow: auto">-->
<!--            <table cellspacing="0" class="allTable alltableHui">-->
<!--              <thead>-->
<!--              <tr style="background-color: #FBFBFB;color: #797979">-->
<!--                <th>应用图标</th>-->
<!--                <th>应用ID</th>-->
<!--                <th>应用名称</th>-->
<!--                <th>是否启用</th>-->
<!--              </tr>-->
<!--              </thead>-->
<!--              <tbody>-->
<!--              <tr :key="index" v-for="(item, index) in appList">-->
<!--                <td><img :src="item.square_Logo_Url" width="45px" height="45px" alt=""></td>-->
<!--                <td>{{item.agentId}}</td>-->
<!--                <td>{{item.name}}</td>-->
<!--                <td>{{item.close === 0 ? '启动': '禁用'}}</td>-->
<!--              </tr>-->
<!--              </tbody>-->
<!--            </table>-->
<!--          </div>-->
        </div>
      </div>
    </model>
  </div>
</template>

<script>
export default {
  name: 'ContentMemberList',
  data () {
    return {
      allgender: '',
      onSearch: false,
      showModel: false,
      tabSwitch: 1,
      totalPage: 1,
      totalCount: 0,
      page: 1,
      postData: {
        pageIndex: 1,
        pageSize: this.$commonJs.commonPageSize,
        userType: 1,
        name: '',
        gender: 2,
        email: '',
        company_Name: '',
        location: '',
        building_Long: '',
        org_Acronym: '',
        IsAttention: false
      },
      myList: [],
      userDetails: {},
      appList: [],
      allcontent: [
        {
          id: -1,
          typeName: '已关注'
        },
        {
          id: true,
          typeName: '是'
        },
        {
          id: false,
          typeName: '否'
        }
      ]
    }
  },
  created () {
    this.getList(1)
  },
  methods: {
    clearPostData () {
      this.postData.gender = 2
      this.postData.name = ''
      this.postData.email = ''
      this.postData.company_Name = ''
      this.postData.location = ''
      this.postData.building_Long = ''
      this.postData.org_Acronym = ''
    },
    // 切换搜索条件
    tewoSearch () {
      this.onSearch = !this.onSearch
    },
    getList (pageIndex) {
      this.postData.pageIndex = pageIndex
      let url = this.$commonJs.returnQuery('/api/user/MultiFilter', this.postData)
      this.$axiox.get(url).then(msg => {
        this.myList = msg.result.items
        this.page = pageIndex
        this.totalPage = Math.ceil(msg.result.totalCount / this.postData.pageSize)
        this.totalCount = msg.result.totalCount
      })
    },
    // 查看用户信息
    viewUserList (object) {
      console.log(object)
      this.showModel = true
      this.userDetails = object
      this.$axiox.get('/api/user/' + object.id + '/apps').then(msg => {
        this.appList = msg.result
      })
    },
    confirModel () {
    },
    cancelModel () {
      this.showModel = false
    },
    allReturn () {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
  #modelSwitah{
    padding:0 10px;
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/contentManger/ContentMemberList.vue